<template>
	<div style="width: 90%;">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<!-- <el-form-item label="商品名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsName" placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<el-form-item label="商品编号" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsCode" placeholder="请输入商品编号"></el-input>
					</el-form-item> -->
					<el-form-item label="状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="0" label="收益中" :value="0">收益中</el-option>
							<el-option key="1" label="已结束" :value="1">已结束</el-option>
							
						</el-select>
					</el-form-item>
					<el-form-item label="结束时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>

						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="dinchun()">添加定存</el-button>
							<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="fixed.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="typename" label="定存周期" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="fixedAmount" label="定存金额" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="rewardRate'" label="收益率" align="center" :show-overflow-tooltip="true">
			
				<template slot-scope="scope">
					<div>{{(scope.row.rewardRate)/100 + '%'}}</div>
					
					
				</template>
			</el-table-column>
				
			<el-table-column prop="status" label="定存状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.status == 1">收益中</div>
					<div v-if="scope.row.status == 0">已结束</div>
					
				</template>
			</el-table-column>
		
			<el-table-column prop="createDate" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="successDate" label="结束时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center" width="140">
				<template slot-scope="scope">
					
					<div v-if="scope.row.status != 0">不可操作</div>
					
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="fixed.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
			:total="fixed.total" @size-change="handleSizeChange">
		</el-pagination>
		
		<el-dialog style="float:rigin" title="新增定存" :closeOnClickModal="false" :visible.sync="applyDatil"
			width="60%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="定存周期">
							<el-select v-model="typename" class="big" placeholder="请选择"
								@change="getStoreName">
								<el-option v-for="item in fiexType" :key="item.id" :value="item.id"
									:label="item.typename">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="定存金额" class='tiny' cleartable>
							<el-input style="width: 200px;" v-model="fixAment" placeholder="请输入定存金额"></el-input>
						</el-form-item>
						
						<el-form-item  label="余额:" class="redItem" style="width: 50%;">
							<span>{{despit}}</span>
							<el-button type="primary" @click="half" style="margin-left: 20px;">提现一半</el-button>
							<el-button @click="allTixian">全部提现</el-button>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="收益率" class='tiny' cleartable>
						{{rewardRate}}
						</el-form-item>
						
						<el-form-item  label="预期收益:" class="redItem" style="width: 50%;">
							{{revenue}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="开始时间:" class='tiny' cleartable>
						{{time}}
						</el-form-item>
						
						<el-form-item  label="结束时间:" class="redItem" style="width: 50%;">
						{{dateAddDays(time,fixDay)}}
						</el-form-item>
					</div>
					
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="安全密码:" class="redItem" style="width: 60%;">
							<!-- <el-input style="width: 200px;" v-model="walletPassword" placeholder="请输入安全密码">
							</el-input> -->
							<el-input style="width: 200px;" placeholder="请输入安全密码" v-model="walletPassword" show-password></el-input>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="applyDatil = false">取 消</el-button>
				<el-button type="primary" @click="sure">确 定</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	export default{
		data(){
			return{
				searchInfo:{},
				loading:false,
				applyDatil:false,
				storeInfo:{},
				fiexId:'',
				time:"",//开始时间
				page: {
					pageNum: 1,
					pageSize: 10
				},
				fixed:{},
				fiexType:[],//定存周期数组
				typename:'',
				despit:'',//余额
				fixAment:'',
				rewardRate:'',//收益率
				fixDay:'',
				walletPassword:'',//安全密码
			}
		},
		computed: {
			revenue(){
				return ((this.fixAment*1) * ( this.rewardRate.slice(0,-1)/100)* (this.fixDay*1)) .toFixed(2)
			}
		},
		methods:{
			search(){
				this.page.pageNum = 1;
				this.fixList()
			},
			empty(){
				this.searchInfo = {}
			},
			// 新增定存弹窗
			dinchun(){
				this.applyDatil = true
				this.typename = this.fiexType[0].id
				this.fixAment = ''
				this.rewardRate =(this.fiexType[0].rewardRate)/100 + '%'
				this.fixDay = this.fiexType[0].fixedDays
				this.walletPassword = ''
			},
			sure(){
				console.log(this.fiexId);
				console.log(this.fixAment)
				if(this.fixAment>this.despit){
					this.$message({
						message: '余额不足，无法提交',
						type: 'warning'
					});
					return
				}
				if(!this.walletPassword){
					this.$message({
						message: '请输入安全密码！',
						type: 'warning'
					});
					return
				}
				let data = {
					fixedType: this.fiexId,
					fixedAmount: this.fixAment,
					payPassword:this.walletPassword
				}
				this.$api.addFixed(data).then(res=>{
					console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.applyDatil = false
						this.fixList()
					}
				})
			},
			getStoreName(e){
				console.log(e);
				this.fiexId  = e
				this.fiexType.map(item =>{
					if(item.id == e){
						this.rewardRate = item.rewardRate/100 + '%'
						this.fixDay = item.fixedDays
						this.fiexId = item.id
					}
				})
			},
			selectStore(){
				this.$api.selectStoreList().then(res=>{
					
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if(res.state == 'success'){
						this.selectStoreName = res.data
					}else {
						this.$message.error(res.message);
					}
				})
			},
			half(){
				this.fixAment = (this.despit * 0.5).toFixed(2)
			},
			allTixian(){
				this.fixAment = this.despit
			},
			
			pageChange(data) {
				this.page.pageNum = data
				this.fixList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.fixList()
			},
			//编辑弹框
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			//获取当前时间，格式YYYY-MM-DD
			getNowTime() {
				var date = new Date();
				//年 getFullYear()：四位数字返回年份
				var year = date.getFullYear(); //getFullYear()代替getYear()
				//月 getMonth()：0 ~ 11
				var month = date.getMonth() + 1;
				//日 getDate()：(1 ~ 31)
				var day = date.getDate();
				// //时 getHours()：(0 ~ 23)
				// var hour = date.getHours();
				// //分 getMinutes()： (0 ~ 59)
				// var minute = date.getMinutes();
				// //秒 getSeconds()：(0 ~ 59)
				// var second = date.getSeconds();
				this.time = year + '-' + this.addZero(month) + '-' + this.addZero(day)
				return this.time;
			},
			addZero(s) {
				return s < 10 ? ('0' + s) : s;
			},
			dateAddDays(dateStr,dayCount) {
			     var tempDate=new Date(dateStr.replace(/-/g,"/"));//把日期字符串转换成日期格式
			     var resultDate=new Date((tempDate/1000+(86400*dayCount))*1000);//增加n天后的日期
			    var resultDateStr=resultDate.getFullYear()+"-"+(resultDate.getMonth()+1)+"-"+(resultDate.getDate());//将日期转化为字符串格式
			   return resultDateStr;
			},
			selectFiextype(){
				this.$api.fixType().then(res=>{
					console.log(res);
					if(res.state == 'success'){
						this.fiexType = res.data
						this.typename = this.fiexType[0].id
						this.rewardRate =(this.fiexType[0].rewardRate)/100 + '%'
						this.fixDay = this.fiexType[0].fixedDays
						this.fiexId = this.fiexType[0].id
					}
				})
			},
			fixList(){
				this.loading = true
					let data = {
						pageNum: this.page.pageNum,
						pageSize: this.page.pageSize,
						startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
						endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
						...this.searchInfo
					}
					this.$api.fixedList(data).then(res=>{
						console.log(res);
						if(res.state == 'success'){
							this.fixed = res.data
							this.loading = false
						}
					})
				}
			
		},
		created() {
			this.selectFiextype()
			this.fixList()
			this.getNowTime()
			this.$api.getUserInfo(this.$encrypt({})).then(res=>{
				
				res.data=JSON.parse(this.$decrypt(res.data)).data
				if(res.state == 'success'){
					this.despit = res.data.deposit
				}
			})
		}
	}
</script>

<style>
</style>